import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do steel building companies attract qualified buyers?",
    "a": "Project galleries by building type, engineering content, and pre-qualifying quote forms. Buyers who match your work self-select. Tire-kickers drop off before they hit your engineer's calendar."
  },
  {
    "q": "Is SEO worth it for steel buildings?",
    "a": "Yes — search volume is stable and project values are high. One commercial steel building offsets months of SEO investment."
  },
  {
    "q": "Should steel building companies run Google Ads?",
    "a": "Yes for commercial, ag, and industrial — with proper negative keywords to exclude DIY-kit shoppers. We build campaigns tuned to your project sweet spot."
  },
  {
    "q": "Do you market across multiple building types?",
    "a": "Yes — ag, commercial, equestrian, industrial, and residential workshops each get dedicated pages. Pages by type rank faster and convert better than one generic 'steel buildings' page."
  },
  {
    "q": "How do we compete with national kit companies?",
    "a": "Local engineering, code knowledge, and finished projects in your service area. Kit companies sell parts; you sell finished buildings. The site has to make that distinction obvious."
  }
];

export const Route = createFileRoute("/steel-building-marketing-colorado")({
  head: () =>
    industryMarketingHead("Steel Building", "steel building company", "steel-building-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Steel Building"}
      industryLower={"steel building company"}
      slug={"steel-building-marketing-colorado"}
      subheadline={"We help Colorado steel building companies — agricultural, commercial, industrial — drive qualified inbound from the right buyers."}
      painPoints={["Tire-kicker quote requests waste your engineering time","DIY kit companies confuse the market and undercut perceived value","You don't show up for 'steel building' in your own state"]}
      serviceDescriptions={{
        seo: "Rank for steel buildings, ag buildings, commercial steel, equestrian, industrial — every building type across every Colorado market.",
        googleMaps: "Own 'steel building contractor' search in your service area with project-photo Map Pack.",
        webDesign: "Project-rich sites with finished project galleries, engineering capability content, and pre-qualifying quote forms.",
        ppc: "Profitable Google Ads tuned to high-value commercial, ag, and industrial steel building searches.",
        geoAi: "Get cited when buyers ask ChatGPT 'best steel building company in Colorado' or 'pole barn builder near me'.",
        socialMedia: "Project completion content that builds trust and pre-sells the engineering capability.",
      }}
      testimonial={{"quote":"Quote quality changed completely. We're building a pipeline of $200k–$1M commercial and ag projects instead of fielding kit shoppers.","role":"Steel Building Company Owner","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Steel building marketing in Colorado Springs","description":"Commercial and ag steel building across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Steel building marketing in Denver","description":"Industrial and commercial steel across the Denver metro."},{"to":"/castle-rock-digital-marketing","label":"Steel building marketing in Castle Rock","description":"Equestrian and luxury workshop builds across Douglas County."}]}
    />
  ),
});
